/**
 * Helper function to check if bending prefix should be added
 * @param {Object} quote - Quote object with finishing_id, binding_option, bend_count
 * @returns {boolean} - True if bending prefix should be added
 */
export const shouldAddBendingPrefix = (quote) => {
  return quote.finishing_id &&
    quote.binding_option !== "no" &&
    quote.bend_count >= 1;
};

/**
 * Formats subquote number by adding "B-" prefix at the beginning
 * Used when constructing new subquote numbers from search_quote
 * @param {Object} quote - Quote object with finishing_id, binding_option, bend_count
 * @param {string} subquoteNumber - Subquote number string to format
 * @returns {string} - Formatted subquote number with "B-" prefix if applicable
 */
export const getFormattedSubquoteNumberFirst = (quote, subquoteNumber) => {
  if (!subquoteNumber || typeof subquoteNumber !== 'string') return subquoteNumber;

  const prefix = shouldAddBendingPrefix(quote) ? "B-" : "";
  // Ensure prefix is added only if it's not already there
  return subquoteNumber.startsWith(prefix) ? subquoteNumber : `${prefix}${subquoteNumber}`;
};

/**
 * Calculates subquote number from individual components
 * Similar to backend calculateSubquoteNumber function
 * Format: "MATERIAL-QUANTITY-B-QUOTE-PART" (if bending) or "MATERIAL-QUANTITY-QUOTE-PART"
 * @param {string|null} materialCode - Material code (uses "TBD" if null)
 * @param {number} quantity - Quantity
 * @param {boolean} bendingPrefix - True if bending prefix should be added
 * @param {string} quoteNumber - Quote number
 * @param {number} index - Zero-based index of the part
 * @returns {string} - Formatted subquote number
 */
export const calculateSubquoteNumber = (materialCode, quantity, bendingPrefix, quoteNumber, index) => {
  const prefix = bendingPrefix ? 'B-' : '';
  const partNumber = String(index + 1).padStart(3, "0");
  const material = materialCode || 'TBD';

  // Format: MATERIAL-QUANTITY-B-QUOTE-PART (B- only if bending)
  return `${material}-${quantity}-${prefix}${quoteNumber}-${partNumber}`;
};